const placeholder = '·';

/**
 * If the given input value is zero/empty/falsy it will return a dash.
 * Otherwise, it will pass the value to the next filter, if provided.
 * Otherwise, it will return the input value as is.
 *
 * @param input
 * @param nextFilter
 */
export const suppressZeroFilter = (input, nextFilter = null) => {
    // Remove whitespace from strings.
    const trimmedInput = typeof input === 'string' ? input.trim() : input;

    if (!trimmedInput || parseFloat(trimmedInput) === 0) {
        // Return a placeholder if the input is empty or zero.
        return placeholder;
    }

    if (nextFilter) {
        return nextFilter(input);
    }

    return input;
};
